export default __webpack_public_path__ + "../img/758dffffec4c8c37b077c7b74d516392.png";